import { IPriceGroup } from 'core/model/interfaces/master-entities';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../shortcuts.constants';
import { IShortcutsState } from '../shortcuts.types';

export const fetchShortcutPriceGroups = createAppAsyncThunk<Array<IPriceGroup>, { shortcutId?: number } | void>(
  `${SLICE_NAMESPACE}/fetchShortcutPriceGroups`,
  async params => {
    try {
      const shortcutId = params?.shortcutId;
      return await apiService.shortcuts.getShortcutPriceGroups(shortcutId);
    } catch (error) {
      notificationService.global.error(handleErrorMessage(error, 'Falló al obtener los grupos de precios.'));

      throw error;
    }
  },
);

export const fetchShortcutPriceGroupsReducer: TSliceExtraReducer<IShortcutsState> = builder =>
  builder
    .addCase(fetchShortcutPriceGroups.pending, state => {
      state.formPriceGroups.isLoading = true;
    })
    .addCase(fetchShortcutPriceGroups.rejected, state => {
      state.formPriceGroups.data = [];
      state.formPriceGroups.isLoading = false;
    })
    .addCase(fetchShortcutPriceGroups.fulfilled, (state, action) => {
      state.formPriceGroups.data = action.payload;
      state.formPriceGroups.isLoading = false;
    });
